<template>
    <div class="container p-md">
        <div class="has-text-right p-t-md">
            <div @click="d1.v=true"
                 :class="'button application-procedure school-button-'+ school">
                <span>{{ $t('candidate.general.admission_process') }}</span> <span class="icon is-small"><i class="fa fa-chevron-right"></i></span></div>
        </div>
        <!--<div class="has-text-right p-b-md p-r-md">
            <router-link class="application-procedure" :to="{ name: 'jpo', params: { school: $route.params.school }}">
                <span>Inscription aux Journées Portes Ouvertes</span>
            </router-link>
        </div>-->

        <vue-slideout-panel v-model="d1.v"
                            closeHtml='<span class="icon is-small"><i class="fa fa-chevron-right"></i></span>'
                            :widths="[responsive.device.isMobile ? '100%':'50%']"
                            :styles="d1.styles"
                            @close="d1.v=false">
            <procedure></procedure>
        </vue-slideout-panel>


        <component
                :is="candidateView"
                :application="application"
                :candidate="candidate">
        </component>
    </div>
</template>

<script>
    import Candidate from './candidate'
    import VueSlideoutPanel from '../../../components/VueSlideoutPanel'
    import Procedure from '../../../components/pages/admissionProcess.vue'
    import {mapGetters, mapState, mapActions} from 'vuex'

    export default {
        components: {
            VueSlideoutPanel,
            Procedure
        },
        data () {
            return {
                activeTab: 0,
                school: '',
                candidateView: Candidate,
                d1: {
                    v: false,
                    styles: [
                        {},
                        {
                            paddingBottom: '1rem'
                        },
                        {},
                        {
                            color: '#555',
                            textDecoration: 'none',
                            top: '1rem',
                            left: '0.1rem'
                        }
                    ],
                },
            }
        },
        computed: {
            ...mapState({
                responsive: 'app'
            }),
            ...mapGetters({
                candidate: 'candidate/getSingleCandidate',
                application: 'candidate/getSingleApplication'
            })

        },
        methods: {
            ...mapActions({
                fetchSchools: 'organization/fetchSchools',
            }),
            selectCandidate(){
                setTimeout(() => {
                    const evt = new UIEvent('resize');
                    window.dispatchEvent(evt);
                }, 100)
            }
        },
        mounted () {
            if (this.$route.hash && this.$route.hash !== '#payment' && this.$route.hash !== '#error') {
                const candidate = this.$route.hash
                //this.activeTab = this.candidates.indexOf(this.candidates.find(c => c.first_name  === candidate.slice( 1 )))
            }
        },
        created () {
            this.fetchSchools()
        }
    }
</script>
<style scoped>

    .candidate-tab {
        font-weight: bold;
    }
    .new-candidate-tab {
        padding: 0.6em;
        border-top: 1px solid #dbdbdb;
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
    }

</style>
